// extracted by mini-css-extract-plugin
module.exports = {"closed":"Modal_closed__1jPwX","overlay":"Modal_overlay__2B9Wi","modal":"Modal_modal__2cjXo","content":"Modal_content__3v_cG","close":"Modal_close__gTqC7"};